import { Routes } from '@angular/router';
import { authGuard } from './authentication/guards/auth.guard';
import { roleGuard } from './authentication/guards/role.guard';
import { deliveredMedicationsGuard } from './shared/guards/delivered-medications.guard';
import { professionalGuard } from './shared/guards/professional.guard';

export const routes: Routes = [
  {
    path: 'redirect',
    loadComponent: () => import('./redirect.component').then(c => c.RedirectComponent),
    children: [
      {
        path: 'prescriptions',
        loadChildren: () => import('./pages/prescriptions/routes').then(r => r.routes),
        canActivate: [authGuard]
      },
      {
        path: '**',
        redirectTo: 'prescriptions',
      },
    ]
  },
  {
    path: '',
    loadComponent: () => import('./app.component').then(c => c.AppComponent),
    children: [
      {
        path: '',
        redirectTo: 'homepage',
        pathMatch: 'full'
      },
      {
        path: 'homepage',
        loadComponent: () => import('./pages/homepage/homepage.component').then(c => c.HomepageComponent),
        canActivate: [authGuard]
      },
      {
        path: 'medications',
        loadChildren: () => import('./pages/medication/routes').then(r => r.routes),
        canActivate: [authGuard, roleGuard]
      },
      {
        path: 'diary-notes',
        loadComponent: () => import('./pages/diary-notes/diary-notes.component').then(c => c.DiaryNotesComponent),
        canActivate: [authGuard, roleGuard]
      },
      {
        path: 'prescriptions',
        loadChildren: () => import('./pages/prescriptions/routes').then(r => r.routes),
        canActivate: [authGuard]
      },
      {
        path: 'delivered-medications',
        loadChildren: () => import('./pages/delivered-medications/routes').then(r => r.routes),
        canActivate: [authGuard, deliveredMedicationsGuard]
      },
      {
        path: 'support',
        loadComponent: () => import('./pages/support-form/support-form.component').then(c => c.SupportFormComponent),
        canActivate: [authGuard, professionalGuard]
      },
      {
        path: 'error',
        loadComponent: () => import('./pages/error/error.component').then(c => c.ErrorComponent)
      },
      {
        path: '**',
        redirectTo: 'homepage'
      }
    ]
  }
];
